import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import 'leaflet.chinatmsproviders'
import Custom from '../lib/CustomWebSDK.min.js'

// 引入 leaflet.markercluster
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet.markercluster'

// wmts结合
import '../lib/leaflet.wmts.min.js'

const createMap = (divId, options) => {
  const map = L.map(divId, options)
  return map
}

// 切片图层
const createLayers = (map, url) => {
  const newLeayer = L.tileLayer(url)
  newLeayer.addTo(map)
  return newLeayer
}

// 注记图层
const createLabels = (map, url) => {
  const labelLayer = new L.GWVTAnno({ tileSize: 512 }) // 都需要引入custom的文件,浙江天地图官方重新定义
  var dataSource = new Custom.URLDataSource()
  dataSource.url = url
  labelLayer.addDataSource(dataSource)
  labelLayer.addTo(map)
  return labelLayer
}

// 点聚合
const createPoints = () => {
  const markers = L.markerClusterGroup({ // 创建加载点位的变量
    maxClusterRadius: 60,
    disableClusteringAtZoom: 18,
    // Disable all of the defaults:
    spiderfyOnMaxZoom: false,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: false
  })
  return markers
}

// wmts图层
const createWmts = (map, url) => {
  const wmtsMap = new L.TileLayer.WMTS(
    url, {
      service: 'WMTS',
      request: 'GetTile',
      version: '1.0.0',
      style: 'default',
      layer: 'zjemap_ter',
      tilematrixset: 'esritilematirx',
      Format: 'image%2Fpng',
      tilematrix: 9,
      token: '8c1e2146-670a-4947-b739-6184b170d5e4'
      // token: '89501c123640e74cad48c088792f94b5'
    })
  wmtsMap.addTo(map)
  return wmtsMap
}
// wmts图层_createWmtsNew (2022/4/20 天地图新要求 )
const createWmtsNew = (map, url) => {
  const wmtsMap = new L.TileLayer.WMTS(
    url, {
      tileMatrixSet: 'imgmap',
      layer: 'vmap',
      token: '8c1e2146-670a-4947-b739-6184b170d5e4'
    })
  wmtsMap.addTo(map)
  return wmtsMap
}
export default {
  createMap,
  createLayers,
  createLabels,
  createPoints,
  createWmts,
  createWmtsNew
}
